import React from "react";

interface CardProps {
    children: React.ReactNode;
}

const FeatureCard: React.FC<CardProps> = ({ children }) => {
    return (
        <div className="card">
            <div className="feature-card">
                {children}
            </div>
        </div>
    )
}

export default FeatureCard;